__webpack_require__.p = "/app/themes/venti/assets/dist/";